import { HR } from 'foundations-components/transitional/components/HR';
import { jsx as _jsx } from "react/jsx-runtime";
const DividerBlock = () => {
  return /*#__PURE__*/_jsx(HR, {
    marginBlock: "200"
  });
};
export default DividerBlock;